import { useCoreSelector } from '../../CoreStore';

import { ChatTabType, Message, ChatSubscriptionState } from './types';

export const useChatSlice = {
  getGameChatMessages: (): Message[] => {
    return useCoreSelector((state) => state.chat.gameChatMessages).filter((message) => message.showMessage);
  },
  getLiveSupportChatMessages: (): Message[] => {
    return useCoreSelector((state) => state.chat.liveSupportChatMessages).filter((message) => message.showMessage);
  },
  getRecentMessages: (): Message[] => {
    return useCoreSelector((state) => state.chat.recentMessages);
  },
  getLastMessage: (): Message | null => {
    return useCoreSelector((state) => state.chat.lastMessage);
  },
  getSelectedTab: (): ChatTabType => {
    return useCoreSelector((state) => state.chat.selectedTab);
  },
  getChatSubscriptionState: (): ChatSubscriptionState => {
    return useCoreSelector((state) => state.chat.chatSubscriptionState);
  },
  getIsLiveSupportOpen: (): boolean => {
    return useCoreSelector((state) => state.chat.selectedTab === ChatTabType.LiveSupportChat);
  },
  getIsLiveSupportRead: (): boolean => {
    return useCoreSelector((state) => state.chat.isLiveSupportChatRead);
  },
  getIsChatClosed: (): boolean => {
    return useCoreSelector((state) => state.chat.isChatClosed);
  },
  getDisplayMiniChat: (): boolean => {
    return useCoreSelector((state) => state.chat.displayMiniChat);
  },
  getIsLiveSupportChatBlocked: (): boolean => {
    return useCoreSelector((state) => state.chat.isLiveSupportChatBlocked);
  },
  getIsGameChatBlocked: (): boolean => {
    return useCoreSelector((state) => state.chat.isGameChatBlocked);
  },
};
